import { OrientationShiftType } from "@clipboard-health/contract-backend-main";
import { isDefined } from "@clipboard-health/util-ts";

import { OrientationShiftInfoCard } from "../../../Shift/BottomSheet/OrientationShiftInfoCard";
import { PreShiftOrientationCard } from "../../../Shift/PreShiftOrientation/OrientationCard";
import { useBookedShiftOrientation } from "../../../Shift/PreShiftOrientation/useBookedShiftOrientation";

interface BookedShiftOrientationCardProps {
  shiftId: string;
  shiftStart: string;
  workplaceTimezone?: string;
  orientationShiftType?: OrientationShiftType;
}

export function BookedShiftOrientationCard(props: BookedShiftOrientationCardProps) {
  const { shiftId, shiftStart, workplaceTimezone, orientationShiftType } = props;

  const { hasPreShiftOrientation, adjustedStart, orientationLengthInMinutes } =
    useBookedShiftOrientation({
      id: shiftId,
      start: shiftStart,
    });

  if (orientationShiftType === "single-shift") {
    return <OrientationShiftInfoCard />;
  }

  if (
    !hasPreShiftOrientation ||
    !isDefined(adjustedStart) ||
    !isDefined(orientationLengthInMinutes)
  ) {
    return null;
  }

  return (
    <PreShiftOrientationCard
      adjustedStart={adjustedStart}
      orientationLengthInMinutes={orientationLengthInMinutes}
      timeZone={workplaceTimezone}
    />
  );
}
